/**
 * OrderBook - 订单簿组件
 * 参照 crypt-trade-gemini.html 的订单簿样式
 *
 * @author page
 * @date 2026-04-23
 */
import React, {useMemo} from 'react';
import styles from './OrderBook.module.css';

interface OrderBookProps {
    bids: Array<{ price: string; quantity: string }>;
    asks: Array<{ price: string; quantity: string }>;
    midPrice?: string;
}

const OrderBook: React.FC<OrderBookProps> = ({
                                                 bids = [],
                                                 asks = [],
                                                 midPrice,
                                             }) => {
    // 计算最大数量（用于计算百分比条宽度）
    const maxQuantity = useMemo(() => {
        const allQuantities = [...bids, ...asks].map(item => Number(item.quantity));
        return Math.max(...allQuantities, 0.001);
    }, [bids, asks]);

    // 渲染订单行
    const renderOrderRow = (price: string, quantity: string, type: 'ask' | 'bid') => {
        const qty = Number(quantity);
        const percent = Math.min((qty / maxQuantity) * 100, 100);

        return (
            <div key={price} className={styles.row}>
                <div
                    className={`${styles.bar} ${type === 'ask' ? styles.askBar : styles.bidBar}`}
                    style={{width: `${percent}%`}}
                />
                <span className={`${styles.price} ${type === 'ask' ? styles.askPrice : styles.bidPrice}`}>
                    {price}
                </span>
                <span className={styles.quantity}>{quantity}</span>
            </div>
        );
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>订单簿</div>
            <div className={styles.content}>
                {/* 卖单列表（低价→高价） */}
                <div className={styles.list}>
                    {asks.slice(0, 5).sort((a, b) => parseFloat(a.price.replace(/,/g, '')) - parseFloat(b.price.replace(/,/g, ''))).map(item => renderOrderRow(item.price, item.quantity, 'ask'))}
                </div>

                {/* 中间价 */}
                <div className={styles.midPrice}>
                    <span className={styles.midPriceValue}>{midPrice || '-'}</span>
                    <span className={styles.midPriceLabel}>标记 -</span>
                </div>

                {/* 买单列表（高价→低价） */}
                <div className={styles.list}>
                    {bids.slice(0, 5).sort((a, b) => parseFloat(b.price.replace(/,/g, '')) - parseFloat(a.price.replace(/,/g, ''))).map(item => renderOrderRow(item.price, item.quantity, 'bid'))}
                </div>
            </div>
        </div>
    );
};

export default OrderBook;
